import styled from 'styled-components'

import rem from '../../../styles/tools/rem'

export const Avatar = styled.img`
  border-radius: 100%;
  height: ${rem('76px')};
  transition: 0.2s box-shadow, 0.2s transform;
  width: ${rem('76px')};
`

export const Label = styled.label`
  cursor: pointer;
  user-select: none;

  :hover {
    ${Avatar} {
      box-shadow: 0 ${rem('6px')} ${rem('11px')} 0 rgba(51, 48, 106, 0.31);
      transform: scale(1.26);
    }
  }
`

export const Input = styled.input`
  display: none;

  :checked + ${Avatar} {
    box-shadow: 0 ${rem('6px')} ${rem('11px')} 0 rgba(51, 48, 106, 0.31);
    transform: scale(1.26);
  }
`



// WEBPACK FOOTER //
// ./src/app/elements/ChooseAvatarOption/styles.js